import PanelCard from 'components/card/PanelCard';
import PostIt from 'components/postIt/PostIt';
import RemunerationConditionsCard from 'components/remunerationSummary/RemunerationConditionsCard';

const DASH = '—';

const rateOf = (bonus) =>
  typeof bonus.payed === 'number' && Number.isFinite(bonus.payed)
    ? `${bonus.payed}%`
    : DASH;

/**
 * What the invoice was billed against (JBWEB-1274): the company's post-it,
 * its remuneration conditions and its bonuses, read-only. Their editors live
 * on the company panel, and the detail keeps a single pencil, the one of its
 * « Informations » card. `company` is what `admin/getCompanyInfo` answers,
 * null while read; `failed` says the read did not succeed.
 */
const InvoiceCompanyTerms = ({ company, failed, companyName, text }) => {
  const terms = (key, fallback) => text(`companyTerms.${key}`, fallback);

  if (failed) {
    return (
      <div role="alert" className="text-sm text-gray-500">
        {terms(
          'loadFailed',
          'Les conditions de l’entreprise n’ont pas pu être chargées.',
        )}
      </div>
    );
  }
  if (!company) return null;

  const bonuses = company.bonusesAndAllowances?.bonuses ?? [];

  return (
    <>
      <PostIt note={company.post_it} companyName={companyName} />
      <RemunerationConditionsCard
        companyInfo={company}
        contentClassName="text-sm"
      />
      <PanelCard
        title={terms('bonusesTitle', 'Primes & indemnités')}
        collapsible
      >
        {bonuses.length === 0 ? (
          <div className="py-3 px-4 text-sm text-gray-500">
            {terms('noBonuses', 'Aucune prime ni indemnité.')}
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase text-gray-500 border-b border-gray-100">
                <th className="px-4 py-3 font-normal">
                  {terms('bonusName', 'Nom')}
                </th>
                <th className="px-4 py-3 font-normal">
                  {terms('bonusUnit', 'Unité')}
                </th>
                <th className="px-4 py-3 font-normal">
                  {terms('bonusRate', 'Majoration')}
                </th>
              </tr>
            </thead>
            <tbody>
              {bonuses.map((bonus, index) => (
                <tr
                  key={bonus._id ?? index}
                  className="border-b border-gray-100 last:border-b-0 text-gray-900"
                >
                  <td className="px-4 py-3">{bonus.name || DASH}</td>
                  <td className="px-4 py-3">{bonus.unit || DASH}</td>
                  <td className="px-4 py-3">{rateOf(bonus)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </PanelCard>
    </>
  );
};

export default InvoiceCompanyTerms;
